package com.sweetlime.bingeamigo.presentation.components

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.aspectRatio
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Star
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.sweetlime.bingeamigo.presentation.ui.BrandColors
import io.kamel.image.KamelImage
import io.kamel.image.asyncPainterResource

/**
 * 2:3 poster tile used in the Search and Library grids.
 *
 * @param posterUrl full TMDB URL, e.g. "https://image.tmdb.org/t/p/w342{path}".
 * @param rating optional ★ rating shown under the title (Search). Pass null in Library.
 * @param overlay optional top-right overlay slot (Library uses it for a remove button).
 */
@Composable
fun PosterTile(
    posterUrl: String,
    title: String,
    onClick: () -> Unit,
    modifier: Modifier = Modifier,
    rating: Double? = null,
    radius: Int = 14,
    overlay: (@Composable BoxScope.() -> Unit)? = null,
) {
    Column(
        modifier = modifier
            .clip(RoundedCornerShape(radius.dp))
            .background(BrandColors.Card)
            .border(1.dp, Color(0xFF2A2A2E), RoundedCornerShape(radius.dp))
            .clickable { onClick() },
    ) {
        Box(Modifier.fillMaxWidth().aspectRatio(2f / 3f).background(Color(0xFF1D1D20))) {
            KamelImage(
                resource = asyncPainterResource(posterUrl),
                contentDescription = title,
                contentScale = ContentScale.Crop,
                modifier = Modifier.fillMaxSize(),
            )
            overlay?.invoke(this)
        }
        Column(Modifier.padding(start = 10.dp, end = 10.dp, top = 8.dp, bottom = 10.dp)) {
            Text(title, color = Color.White, fontWeight = FontWeight.Bold, fontSize = 13.sp, maxLines = 1, overflow = TextOverflow.Ellipsis)
            if (rating != null) {
                Spacer(Modifier.height(4.dp))
                Row(verticalAlignment = Alignment.CenterVertically) {
                    Icon(Icons.Filled.Star, null, tint = BrandColors.Primary, modifier = Modifier.size(12.dp))
                    Spacer(Modifier.width(4.dp))
                    Text(formatRating(rating), color = BrandColors.Primary, fontSize = 12.sp, fontWeight = FontWeight.Bold)
                }
            }
        }
    }
}

private fun formatRating(r: Double): String {
    val whole = r.toInt()
    val tenth = ((r - whole) * 10).toInt()
    return "$whole.$tenth"
}

// Re-export BoxScope so callers don't need the import.
typealias BoxScope = androidx.compose.foundation.layout.BoxScope
